export enum UserInterfaceSettings {
    AsideMenu = 'App.MazarsUserInterface.AsideMenu',
}
